import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
Vue.use(Vuetify)
const vuetify = new Vuetify({
  theme: {
    themes: {
      light: {
        // primary: '#90C143',
        // primary: '#3ca8bf',
        primary: '#4e73df',

        secondary: '#b0bec5',
        anchor: '#8c9eff',
      },
    },
  },
})
const opts = {}

export default new Vuetify(opts)